import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['permiteRelatorioAnexado', 'periodicidade', 'podeDefinirLotacaoAvaliador', 'permiteAnexarArquivos',
                    'exigeAnexoEnviarRelatorio', 'prazoSemanalPreenchimento', 'diasCorridosPreenchimentoRelatorio',
                    'diasUteisEnvioRelatorio']

  connect() {
    this.previousValueRelatorioMensalSemanasSeparadas = this.relatorioMensalComSemanasSeparadas().checked;
    this.toogleRelatorioMensalComSemanasSeparadas();
    this.tooglePodeDefinirLotacaoAvaliador();
    this.exibeEscondeCampoExigeAnexo();
    this.togglePrazoSemanalPreenchimento();
  }

  toogleRelatorioMensalComSemanasSeparadas() {
    const periodicidade = this.periodicidadeTarget?.value;
    const permiteRelatorioAnexado = Boolean(this.permiteRelatorioAnexadoTarget?.checked);

    const containerElemento = document.getElementById('relatorio_mensal_fisico_com_semanas_separadas_elemento');
    if (!containerElemento) {
      console.error('Elemento relatorio_mensal_fisico_com_semanas_separadas_elemento não encontrado!');
      return;
    }

    if (periodicidade == 'mensal' && permiteRelatorioAnexado) {
      containerElemento.style.display = '';
      const elemento = this.relatorioMensalComSemanasSeparadas();
      elemento.checked = this.previousValueRelatorioMensalSemanasSeparadas;
    } else {
      containerElemento.style.display = 'none';
      const elemento = this.relatorioMensalComSemanasSeparadas();
      this.previousValueRelatorioMensalSemanasSeparadas = elemento.checked;
      elemento.checked = false;
    }
  }

  tooglePodeDefinirLotacaoAvaliador() {
    const podeDefinirLotacaoAvaliador = Boolean(this.podeDefinirLotacaoAvaliadorTarget?.checked);

    const containerElemento = document.getElementById('lotacao_avaliador_elemento');
    if (!containerElemento) {
      console.error('Elemento pode_definir_lotacao_avaliador_elemento não encontrado!');
      return;
    }
    if (podeDefinirLotacaoAvaliador) {
      containerElemento.style.display = '';
    } else {
      containerElemento.style.display = 'none';
    }
  }

  exibeEscondeCampoExigeAnexo() {
    const elemento = document.getElementById('exige_anexo_enviar_relatorios');

    if (this.permiteAnexarArquivosTarget?.checked) {
      elemento.style.display = '';
    } else {
      this.exigeAnexoEnviarRelatorioTarget.checked = false;
      elemento.style.display = 'none';
    }
  }

  relatorioMensalComSemanasSeparadas() {
    const elemento = document.getElementById('tipo_relatorio_relatorio_mensal_fisico_com_semanas_separadas');
    return elemento;
  }

  togglePrazoSemanalPreenchimento() {
    const periodicidade = this.periodicidadeTarget?.value;
    const containerElemento = document.getElementById('prazo_semanal_preenchimento_elemento');
    if (!containerElemento) {
      console.error('Elemento prazo_semanal_preenchimento_elemento não encontrado!');
      return;
    }

    if (periodicidade === 'semanal') {
      containerElemento.style.display = '';
    } else {
      containerElemento.style.display = 'none';
      if (this.prazoSemanalPreenchimentoTarget) {
        this.prazoSemanalPreenchimentoTarget.checked = false;
      }
    }

    this.toggleDiasCorridosPreenchimento();
  }

  toggleDiasCorridosPreenchimento() {
    const containerElemento = document.getElementById('dias_corridos_preenchimento_relatorio_elemento');
    if (!containerElemento) {
      console.error('Elemento dias_corridos_preenchimento_relatorio_elemento não encontrado!');
      return;
    }

    if (this.prazoSemanalPreenchimentoTarget?.checked) {
      containerElemento.style.display = '';
      if (this.diasCorridosPreenchimentoRelatorioTarget) {
        this.diasCorridosPreenchimentoRelatorioTarget.required = true;
      }
    } else {
      containerElemento.style.display = 'none';
      if (this.diasCorridosPreenchimentoRelatorioTarget) {
        this.diasCorridosPreenchimentoRelatorioTarget.value = '';
        this.diasCorridosPreenchimentoRelatorioTarget.required = false;
        this.diasCorridosPreenchimentoRelatorioTarget.setCustomValidity('');
      }
    }
    this.validateDiasCorridosPreenchimento();
  }

  validateDiasCorridosPreenchimento() {
    if (!this.prazoSemanalPreenchimentoTarget?.checked) {
      return;
    }

    const diasCorridos = parseInt(this.diasCorridosPreenchimentoRelatorioTarget?.value, 10);
    const diasUteis = parseInt(this.diasUteisEnvioRelatorioTarget?.value, 10);
    let mensagemErro = '';

    if (!Number.isNaN(diasCorridos) && !Number.isNaN(diasUteis) && diasCorridos > diasUteis) {
      mensagemErro = 'deve ser menor ou igual aos dias úteis para envio do relatório';
    }

    if (!Number.isNaN(diasCorridos) && diasCorridos > 7) {
      mensagemErro = 'deve ser menor ou igual a 7';
    }

    this.diasCorridosPreenchimentoRelatorioTarget?.setCustomValidity(mensagemErro);
  }
}
